import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import * as S from "../dashboard/_shared";
import "./style.scss";

export default function EvaChatHistory({
  chats,
  ativoId,
  onSelect,
  onNew,
  onDelete,
  onDeleteAll,
}) {
  const { C } = S;
  const [hoverId, setHoverId] = useState(null);

  function tempoRelativo(ts) {
    const diff = Date.now() - ts;
    const min = Math.floor(diff / 60000);
    if (min < 1) return "agora";
    if (min < 60) return `há ${min} min`;
    const h = Math.floor(min / 60);
    if (h < 24) return `há ${h}h`;
    const dias = Math.floor(h / 24);
    if (dias === 1) return "ontem";
    if (dias < 7) return `há ${dias} dias`;
    const dt = new Date(ts);
    return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}`;
  }

  return (
    <div className="compEvaChatHistory">
      {/* Header com botão Nova conversa */}
      <div className="header">
        <button onClick={onNew} className="newChatBtn">
          <Plus size={14} /> Nova conversa
        </button>
      </div>
      {/* Label */}
      <div className="historyLabel">Histórico ({chats.length})</div>
      {/* Lista scrollável */}
      <div className="list">
        {chats.length === 0 ? (
          <div className="emptyState">Nenhuma conversa ainda.</div>
        ) : (
          chats.map((c) => {
            const isActive = c.id === ativoId;
            const isHover = hoverId === c.id;
            return (
              <div
                key={c.id}
                onClick={() => onSelect(c.id)}
                onMouseEnter={() => setHoverId(c.id)}
                onMouseLeave={() => setHoverId(null)}
                className={`chatItem${isActive ? " is-active" : ""}${isHover ? " is-hover" : ""}`}
              >
                <div className="chatItemTitle">{c.title}</div>
                <div className="chatItemTime">
                  {tempoRelativo(c.createdAt)} · {c.messages.length}{" "}
                  {c.messages.length === 1 ? "msg" : "msgs"}
                </div>
                {/* Delete on hover */}
                {isHover && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(c.id);
                    }}
                    title="Excluir conversa"
                    className="deleteBtn"
                  >
                    <Trash2 size={12} />
                  </button>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
